import { render, staticRenderFns } from "./QueueStats.vue?vue&type=template&id=062615e4&"
import script from "./QueueStats.vue?vue&type=script&lang=ts&"
export * from "./QueueStats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports